import { ToasterViewPort } from './ToasterViewPort';
import { createPortal } from 'react-dom';
import { useEffect } from 'react';
import { useToaster } from './useToaster';
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
/**
 * Represents a toaster component.
 *
 * @typedef {object} Toaster
 * @property {string} containerId - The id of the container where the toaster is mounted.
 *
 * @param {Toaster} props - The props to configure the toaster.
 * @returns {JSX.Element} The rendered toaster component.
 */
export const Toaster = props => {
  const {
    containerId
  } = props;
  const {
    toast
  } = useToaster();

  // Receive messages from child toasters
  const handlePostMessage = event => {
    const options = {
      ...event.data.options,
      source: event.source,
      origin: event.origin
    };
    if (event.data && event.data.type === 'ADD_TOAST') {
      toast(event.data.title, event.data.message, event.data.onClick, undefined, options);
    }
  };

  // Setup up listener to listen for requests to display toasts from children
  useEffect(() => {
    window.addEventListener('message', handlePostMessage);

    // Cleanup: Remove the event listener when the component unmounts
    return () => {
      window.removeEventListener('message', handlePostMessage);
    };
  }, []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/createPortal( /*#__PURE__*/_jsx(ToasterViewPort, {
      containerId: containerId
    }), document.body)
  });
};